define.alias("shared/components/shared/ui/icon-tooltip", "settings/components/shared/ui/icon-tooltip");